import { EnvironmentService } from 'phoenix/services';

export function RightClickDirective(
	$parse:ng.IParseService, 
	pxEnvironmentService:EnvironmentService
) {
	return function(scope, element, attrs) {
		if(!pxEnvironmentService.touchEnabled){
			var fn = $parse(attrs.ngRightClick);
			element.bind('contextmenu', function(event) {
				scope.$apply(function() {
					event.preventDefault();
					fn(scope, {$event:event});
				});
			});
		}
	};
}

RightClickDirective.$inject = [
	'$parse', 
	'pxEnvironmentService'
];


// WEBPACK FOOTER //
// ./src/phoenix/components/ngRightClick/ngRightClick.ts